import * as CustomerContactsForm from './CustomerContactsForm.css';
import * as CustomerContactsModal from './Modal/CustomerContactsModal.css';
export default {
    CustomerContactsForm,
    CustomerContactsModal
};
